var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.29202 9.46202L8.17202 5.58202L4.29202 1.70202C4.19944 1.60944 4.126 1.49953 4.07589 1.37856C4.02579 1.2576 4 1.12795 4 0.997021C4 0.86609 4.02579 0.736442 4.07589 0.615478C4.126 0.494513 4.19944 0.384603 4.29202 0.292021C4.3846 0.199439 4.49451 0.125999 4.61548 0.0758939C4.73644 0.0257889 4.86609 -9.75508e-10 4.99702 0C5.12795 9.7551e-10 5.2576 0.0257889 5.37856 0.0758939C5.49953 0.125999 5.60944 0.199439 5.70202 0.292021L10.292 4.88202C10.682 5.27202 10.682 5.90202 10.292 6.29202L5.70202 10.882C5.60951 10.9747 5.49962 11.0483 5.37864 11.0985C5.25767 11.1486 5.12799 11.1745 4.99702 11.1745C4.86605 11.1745 4.73637 11.1486 4.6154 11.0985C4.49442 11.0483 4.38453 10.9747 4.29202 10.882C3.91202 10.492 3.90202 9.85202 4.29202 9.46202Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.daf98eae1d6ed54eda99ff8b87e339e0.svg";
export { ForwardRef as ReactComponent };